import pe from "./pe.json";
import en from "./en.json";

export const dictionaryList = { en, pe };
export const languageOptions = {
  en: "English",
  pe: "فارسی",
};
